import { Link } from "react-router-dom";
import { useStudentCohorts } from "../student/StudentCohortContext";

export default function StudentCohortsPage() {
  const { cohorts, loading, error } = useStudentCohorts();

  return (
    <main className="page page-align-start student-page-inner">
      <div className="card card-wide">
        <header className="row-header">
          <div>
            <p className="eyebrow">Student</p>
            <h1>My cohorts</h1>
            <p className="lede">Classes you are actively enrolled in.</p>
          </div>
          {cohorts.length > 0 ? (
            <Link to="/join" className="btn primary">
              Join another cohort
            </Link>
          ) : null}
        </header>

        {error ? (
          <div className="warn-banner" role="alert">
            {error}
          </div>
        ) : null}

        {loading ? (
          <p className="muted">Loading cohorts…</p>
        ) : cohorts.length === 0 ? (
          <p className="muted">
            You are not in a cohort yet. Ask your teacher for a join code, then{" "}
            <Link to="/join">join a cohort</Link>.
          </p>
        ) : (
          <ul className="student-cohort-list">
            {cohorts.map((c) => (
              <li key={c.cohortId} className="student-cohort-list-item">
                <div>
                  <strong>{c.label}</strong>
                  <p className="muted small" style={{ margin: "0.2rem 0 0" }}>
                    {c.courseTitle}
                  </p>
                </div>
                <Link to={`/lessons?cohort=${c.cohortId}`} className="btn secondary tight">
                  View lessons
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </main>
  );
}
